import {get, pick} from "lodash";
import {price, thumb} from "@/modules/utils";
import counterFull from "@/components/counter/full.vue";

export default {
	components: {counterFull},
	props: {
		id: {type: Number, required: true},
		url: {type: String, required: true},
		title: {type: String, required: true},
		image: {type: String, required: false},
		variants: {type: Array, required: true},
		variantsOpen: {type: Boolean, required: true}
	},
	computed: {
		sku: (t) => t.variant.sku,
		rules: (t) => t.variant.rules,
		variant: (t) => t.variants[0],
		multi: (t) => t.variants.length > 1,
		price: (t) => price(t.variant.price),
		thumb: (t) => thumb({url: t.image, size: "128"}),
		cartProduct: (t) => t.$store.getters["cart/products"].find(x => x.id === t.id),
		itemsCount: t => get(t.cartProduct, "line_items", []).reduce((sum, {quantity}) => sum + quantity, 0)
	},
	methods: {
		toggleVariants() {
			this.$parent.$emit("update:variantsOpen", !this.variantsOpen);
		}
	},
	render() {
		return this.$scopedSlots.default(pick(this, [
			"variant",
			"multi",
			"price",
			"rules",
			"sku",
			"url",
			"thumb",
			"cartProduct",
			"itemsCount",
			"toggleVariants",
			"title"
		]));
	}
};
